var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-tasks-wrapper",
    },
    [
      _vm.tasks.length > 0
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$gettext("Status")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$gettext("Aufgabe")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$gettext("bearbeitet")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$gettext("Abgabefrist")))]),
                  _vm._v(" "),
                  _c("th", [_vm._v(_vm._s(_vm.$gettext("Abgabe")))]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "responsive-hidden",
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Verlängerungsanfrage")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "responsive-hidden",
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Anmerkung")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "actions",
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Aktionen")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.tasks, function (_ref) {
                  var _task$attributes, _task$attributes$prog
                  var task = _ref.task,
                    taskGroup = _ref.taskGroup,
                    status = _ref.status,
                    element = _ref.element,
                    feedback = _ref.feedback
                  return _c(
                    "tr",
                    {
                      key: task.id,
                    },
                    [
                      _c(
                        "td",
                        [
                          status.shape !== undefined
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: status.shape,
                                  role: status.role,
                                  title: status.description,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.getLinkToElement(element),
                            },
                          },
                          [
                            task.attributes["solver-type"] === "group"
                              ? _c("studip-icon", {
                                  attrs: {
                                    shape: "group2",
                                    title: _vm.$gettext("Gruppenaufgabe"),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(taskGroup.attributes.title) +
                                "\n                    "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            ((_task$attributes = task.attributes) === null ||
                            _task$attributes === void 0
                              ? void 0
                              : (_task$attributes$prog =
                                  _task$attributes.progress) === null ||
                                _task$attributes$prog === void 0
                              ? void 0
                              : _task$attributes$prog.toFixed(0)) || "-"
                          ) + "%"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.getReadableDate(
                              task.attributes["submission-date"]
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          task.attributes.submitted
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: "accept",
                                  role: "status-green",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "declined",
                                  expression:
                                    "task.attributes.renewal === 'declined'",
                                },
                              ],
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "decline",
                                  role: "status-red",
                                },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("Anfrage abgelehnt")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "pending",
                                  expression:
                                    "task.attributes.renewal === 'pending'",
                                },
                              ],
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "date",
                                  role: "status-yellow",
                                },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$gettext("Anfrage wird bearbeitet")
                                  ) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "granted",
                                  expression:
                                    "task.attributes.renewal === 'granted'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("verlängert bis")) +
                                  ": " +
                                  _vm._s(
                                    _vm.getReadableDate(
                                      task.attributes["renewal-date"]
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          feedback
                            ? _c("studip-icon", {
                                staticClass: "display-feedback",
                                attrs: {
                                  title: _vm.$gettext("Anmerkung anzeigen"),
                                  shape: "consultation",
                                  role: "clickable",
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.displayFeedback(feedback)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "actions",
                        },
                        [
                          _c("studip-action-menu", {
                            attrs: {
                              items: _vm.getTaskMenuItems(
                                task,
                                status,
                                element
                              ),
                            },
                            on: {
                              submitTask: function submitTask($event) {
                                return _vm.displaySubmitDialog(task)
                              },
                              renewalRequest: function renewalRequest($event) {
                                return _vm.renewalRequest(task)
                              },
                              copyContent: function copyContent($event) {
                                return _vm.copyContent(taskGroup, element)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _c(
            "div",
            [
              _c("courseware-companion-box", {
                attrs: {
                  mood: "sad",
                  msgCompanion: _vm.$gettext(
                    "Es wurden bisher keine Aufgaben gestellt."
                  ),
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.showFeedbackDialog
        ? _c("studip-dialog", {
            attrs: {
              message: _vm.currentTaskFeedback,
              title: _vm.text.feedbackDialog.title,
            },
            on: {
              close: function close($event) {
                _vm.showFeedbackDialog = false
                _vm.currentTaskFeedback = ""
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSubmitDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.text.submitDialog.title,
              question: _vm.text.submitDialog.question,
              height: "200",
              width: "420",
            },
            on: {
              confirm: _vm.submitTask,
              close: _vm.closeSubmitDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [_c("col")])
  },
]
render._withStripped = true

export { render, staticRenderFns }